export const TEMPLATE_TAGS = [
    // Contract style
    'beginner',
    'intermediate',
    'advanced',
    'hardcore',
    'casual',

    // Balance tiers
    'low-balance',
    'mid-balance',
    'high-balance',

    // Duration
    'short-term',
    'long-term',
    'open-ended',

    // Theme
    'findom',
    'debt',
    'tribute',
    'worship',
    'gamble',
    'punishment',

    // Structure
    'exclusive',
    'competitive',
    'team',

    // Special
    'new-dom',
    'interactive',
    'high-interest',
    'low-interest',
] as const;

export type TemplateTag = (typeof TEMPLATE_TAGS)[number];
